import { useNavigate } from '@tanstack/react-router'
import { CompassIcon } from 'lucide-react'

import { useIsTrialAccount } from '@/modules/account'
import { useHelpActions } from '@/modules/help/store'

// The permanent way to the walkthrough once the nudges are gone.
export function GettingStartedHelpLink() {
  const navigate = useNavigate()
  const { close } = useHelpActions()
  const isTrial = useIsTrialAccount()

  const openWalkthrough = () => {
    close()
    navigate({ to: '/getting-started' })
  }

  if (isTrial) return null

  return (
    <button
      type="button"
      onClick={openWalkthrough}
      className="inline-flex cursor-pointer items-center gap-1.5 text-xs font-medium text-blue-6 transition-colors hover:text-brand"
    >
      <CompassIcon className="h-3.5 w-3.5" />
      New here? Open the Getting started walkthrough
    </button>
  )
}
